import { useState, useCallback } from "react";
import LoadingDisplay from "../../../common/LoadingDisplay/LoadingDisplay";
import memeService from "../../../../services/MemeService";
import DisplayLogic from "./DisplayLogic";
import PreloadTemplateService from "../../../../services/PreloadService/PreloadTemplateService";
import notificationService from "../../../../services/NotificationService";
import { useTranslation } from "react-i18next";
import useAsync from "../../../../services/useAsync";
const Upload = () => {
    const { t } = useTranslation("templatesPage");

    const [isLoading, setIsLoading] = useState(true);
    const [userSettings, setUserSettings] = useState(null);
    const [priceOptions, setPriceOptions] = useState(null);

    const {
        selectedTemplates,
        uploadedTemplates,
        replaceSelectedTemplate,
        addFirstSelectedTemplate,
        deleteSelectedTemplate,
        loadSelectedTemplates,
        replaceUploadedTemplate,
        addFirstUploadedTemplate,
        deleteUploadedTemplate,
        loadUploadedTemplates,
        updateSelectedTemplate,
    } = PreloadTemplateService();

    const getPriceList = async () => {
        try {
            const priceOptionsResponse = await memeService.getPriceOptions();
            setPriceOptions(priceOptionsResponse.priceOptions);
        } catch (error) {
            notificationService.setMessage(t("cannotGetPriceMessage"));
        }
    };

    const loadUserSettings = async () => {
        let settings = await memeService.getBroadcasterSettings();
        setUserSettings(settings);
        return;
    };

    const loadPage = useCallback(async () => {
        setIsLoading(true);
        await Promise.all([
            loadUploadedTemplates(),
            loadSelectedTemplates(),
            loadUserSettings(),
            getPriceList(),
        ]);
        setIsLoading(false);
    }, [loadUploadedTemplates, loadSelectedTemplates]);

    useAsync(loadPage);

    let displayComponent = <></>;

    if (isLoading) displayComponent = <LoadingDisplay />;
    if (!isLoading)
        displayComponent = (
            <DisplayLogic
                uploadedTemplates={uploadedTemplates}
                userSettings={userSettings}
                selectedTemplates={selectedTemplates}
                deleteSelectedTemplate={deleteSelectedTemplate}
                deleteUploadedTemplate={deleteUploadedTemplate}
                replaceUploadedTemplate={replaceUploadedTemplate}
                addFirstSelectedTemplate={addFirstSelectedTemplate}
                addFirstUploadedTemplate={addFirstUploadedTemplate}
                replaceSelectedTemplate={replaceSelectedTemplate}
                updateSelectedTemplate={updateSelectedTemplate}
                priceOptions={priceOptions}
            />
        );

    return displayComponent;
};

export default Upload;
